import Modal from '../Modal';
import { useEffect, useState } from 'react';
import {
    ChevronRightIcon,
    UserIcon,
} from '@heroicons/react/24/outline/index.js';
import TextInput from '../TextInput';
import Select from '../Select';
import OptionalTimeZoneSelect from './OptionalTimeZoneSelect.jsx';
import SelectResourceType from './SelectResourceType.jsx';
import TextArea from '../TextArea.jsx';

function ChairIcon(props) {
    return (
        <svg
            width={40}
            height={41}
            viewBox="0 0 40 41"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M19.037 12.227h1.927M13.39 14.886c.115-.803 0-1.556 0-2.229-1.005-.811-1.666-1.55-1.852-3.27-.142-1.317 1.016-2.294 2.27-2.721 2.874-.978 2.622-3.287 6.19-3.287 3.569 0 3.318 2.309 6.191 3.287 1.254.427 2.412 1.404 2.27 2.722-.186 1.718-.847 2.458-1.852 3.27 0 .672-.114 1.425 0 2.229M5.51 19.441h3.607l1.58 6.014a2.634 2.634 0 002.548 1.964h13.51a2.634 2.634 0 002.548-1.965l1.58-6.013h3.606M10.834 37.62v-.963c.771-.473 3.684-1.42 9.166-1.42M29.166 37.62v-.963c-.771-.473-3.684-1.42-9.166-1.42M20.001 27.419l-.003 7.817"
                stroke="#2C87F3"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

const AddBookableResourceModal = ({ isOpen, onClose, doSubmit, addType }) => {
    const [isSaving, setIsSaving] = useState(false);
    const [name, setName] = useState('');
    const [type, setType] = useState('chair');
    const [timezone, setTimezone] = useState('');
    const [description, setDescription] = useState('');
    const [capacity, setCapacity] = useState(1);

    useEffect(() => {
        if (!isOpen) {
            // Reset
            setName('');
            setTimezone('');
            setCapacity(1);
            setDescription('');
        }
    }, [isOpen]);

    async function submit(type) {
        setIsSaving(true);
        try {
            await doSubmit({ type, name, capacity, description });
            onClose();
        } catch (e) {
            // ...
        }

        setIsSaving(false);
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <div>
                {addType === 'person' && (
                    <div>
                        <h2 className="mb-4">Add Person</h2>
                        <TextInput
                            id="name"
                            label="Name"
                            inputClassName="w-full"
                            value={name}
                            onChange={setName}
                            autoFocus={true}
                        />
                        <TextArea
                            id="description"
                            label="Description"
                            placeholder="Description (optional)"
                            value={description}
                            onChange={setDescription}
                            className="mt-4"
                        />
                        <OptionalTimeZoneSelect
                            className="text-sm mt-1"
                            noLink={true}
                            selectClassName="mt-4"
                            value={timezone}
                            onChange={setTimezone}
                            defaultLabel={
                                <div className="text-gray-500 mt-1 mb-3">
                                    Time zone is the same as the business{' '}
                                    <span className="underline ml-1">
                                        Change
                                    </span>
                                </div>
                            }
                        />
                        <div className="flex flex-wrap gap-2 xs:flex-nowrap items-center mt-4">
                            <button
                                className="btn-save w-full xs:w-auto"
                                type="button"
                                onClick={() => submit('Person')}
                            >
                                {isSaving ? 'Saving...' : 'Continue'}
                            </button>
                            <button
                                className="btn-gray-pill-lg w-full xs:w-auto"
                                type="button"
                                onClick={onClose}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                )}
                {addType !== 'person' && (
                    <div>
                        <h2 className="mb-3">Add Bookable Thing</h2>
                        <p className="mb-6 text-gray-500">
                            Add availability for a room, lane, seat, etc. that
                            clients can choose to book with
                        </p>
                        <TextInput
                            id="name"
                            label="Name"
                            className="mb-2"
                            inputClassName="w-full"
                            value={name}
                            onChange={setName}
                            autoFocus={true}
                        />

                        <TextArea
                            id="description"
                            label="Description"
                            placeholder="Description (optional)"
                            value={description}
                            onChange={setDescription}
                            className="mt-4"
                        />

                        <SelectResourceType value={type} onChange={setType} />

                        <TextInput
                            id="capacity"
                            label={`How many ${type ? type.toLowerCase() + 's' : ''} are available for clients to book?`}
                            className="mt-4"
                            type="number"
                            inputClassName="w-full"
                            value={capacity}
                            onChange={newValue =>
                                setCapacity(Math.max(1, newValue))
                            }
                        />

                        <div className="flex flex-wrap gap-2 xs:flex-nowrap items-center mt-4">
                            <button
                                className="btn-save w-full xs:w-auto"
                                type="button"
                                onClick={() => submit(type)}
                            >
                                {isSaving ? 'Saving...' : 'Continue'}
                            </button>
                            <button
                                className="btn-gray-pill-lg w-full xs:w-auto"
                                type="button"
                                onClick={onClose}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default AddBookableResourceModal;
